import { apiBasePath } from "../../constants/constants";
import ApiService from "../../utils/api-service";

function addOffset(data, apiUrl) {
  if (data?.offset !== undefined) {
    apiUrl += `&offset=${data?.offset * 20}`;
  }
  return apiUrl;
}

function addSortBy(data, apiUrl) {
  if (data?.sortBy !== undefined && data?.sortBy !== null) {
    apiUrl += `&sortBy=${data?.sortBy}`;
  }
  return apiUrl;
}

function addSortOrder(data, apiUrl) {
  if (data?.sortOrder !== undefined && data?.sortOrder !== null) {
    apiUrl += `&sortOrder=${data?.sortOrder}`;
  }
  return apiUrl;
}

function addMentorNameEmail(data, apiUrl) {
  if (
    data?.mentorNameOrEmail !== undefined &&
    data?.mentorNameOrEmail !== null &&
    data?.mentorNameOrEmail !== ""
  ) {
    apiUrl += `&mentorNameOrEmail=${data?.mentorNameOrEmail}`;
  }
  return apiUrl;
}

function addAttendeeNameEmail(data, apiUrl) {
  if (
    data?.attendeeNameOrEmail !== undefined &&
    data?.attendeeNameOrEmail !== null &&
    data?.attendeeNameOrEmail !== ""
  ) {
    apiUrl += `&attendeeNameOrEmail=${data?.attendeeNameOrEmail}`;
  }
  return apiUrl;
}

function addCompetencies(data, apiUrl) {
  if (
    data?.competencyIds !== undefined &&
    data?.competencyIds !== null &&
    data?.competencyIds.length
  ) {
    apiUrl += `&competencyIds=${data?.competencyIds}`;
  }
  return apiUrl;
}

function addBootcamps(data, apiUrl) {
  if (
    data?.bootcampIds !== undefined &&
    data?.bootcampIds !== null &&
    data?.bootcampIds !== ""
  ) {
    apiUrl += `&bootcampIds=${data?.bootcampIds}`;
  }
  return apiUrl;
}

function addBatches(data, apiUrl) {
  if (
    data?.batchIds !== undefined &&
    data?.batchIds !== null &&
    data?.batchIds.length
  ) {
    apiUrl += `&batchIds=${data?.batchIds}`;
  }
  return apiUrl;
}

function addStatus(data, apiUrl) {
  if (
    data?.status !== undefined &&
    data?.status !== null &&
    data?.status !== ""
  ) {
    apiUrl += `&status=${data?.status}`;
  }
  return apiUrl;
}

function addShowAttendees(data, apiUrl) {
  if (data?.showAttendees) {
    apiUrl += `&showAttendees=${data?.showAttendees}`;
  }
  return apiUrl;
}

function addShowMentees(data, apiUrl) {
  if (data?.showMentees) {
    apiUrl += `&showMentees=${data?.showMentees}`;
  }
  return apiUrl;
}

function addShowReviewees(data, apiUrl) {
  if (data?.showReviewees) {
    apiUrl += `&showReviewees=${data?.showReviewees}`;
  }
  return apiUrl;
}

function addBootcamp(data, apiUrl) {
  if (data?.bootcampId) {
    apiUrl += `&bootcampId=${data?.bootcampId}`;
  }
  return apiUrl;
}

export function getAttendeesApi(data) {
  let apiUrl = `${apiBasePath}/sessionAttendance?sessionId=${data?.sessionId}&max=20`;
  apiUrl = addOffset(data, apiUrl);
  apiUrl = addSortBy(data, apiUrl);
  apiUrl = addSortOrder(data, apiUrl);
  apiUrl = addMentorNameEmail(data, apiUrl);
  apiUrl = addAttendeeNameEmail(data, apiUrl);
  apiUrl = addCompetencies(data, apiUrl);
  apiUrl = addBootcamps(data, apiUrl);
  apiUrl = addBatches(data, apiUrl);
  apiUrl = addStatus(data, apiUrl);
  apiUrl = addShowAttendees(data, apiUrl);
  apiUrl = addShowMentees(data, apiUrl);
  apiUrl = addShowReviewees(data, apiUrl);
  apiUrl = addBootcamp(data, apiUrl);

  const options = {
    method: "GET",
    url: apiUrl
  };
  return ApiService(options);
}

export function markAttendanceApi(data) {
  let apiUrl = `${apiBasePath}/sessionAttendance`;

  const options = {
    method: "PUT",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getCompetencyApi(data) {
  let apiUrl = `${apiBasePath}/competencies`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getBatchesApi(data) {
  let apiUrl = `${apiBasePath}/moduleBatches?moduleId=${data.moduleId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function createAttendancesApi(data) {
  let apiUrl = `${apiBasePath}/sessionAttendance?sessionId=${data.sessionId}`;

  const options = {
    method: "POST",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getFiltersForAttendeesTabApi({ sessionId }) {
  let apiUrl = `${apiBasePath}/utilities/filtersForSessionAttendanceListing?sessionId=${sessionId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}
